import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";

interface Props {
    instanceId: string;
    onTaskStarted: (taskId: string) => void;
}

class DeleteOutboundPrivateLinkDialog extends DataBaseComponent<Props, DataBaseComponentState> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return <SaveDialogLayout title={"Delete Outbound Private Link"}
            onSaveClick={() => this.deleteOutboundPrivateLink()}
            errors={this.state.errors}
            saveButtonLabel={"Delete"}
            busy={this.state.busy}>
            <p>Are you sure you want to delete the outbound private link resources for this instance?</p>
            <p>This will remove the private endpoint and associated configurations.</p>
        </SaveDialogLayout>;
    }

    private async deleteOutboundPrivateLink(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const taskId = await repository.HostedInstances.deleteOutboundPrivateLink(this.props.instanceId);
            this.props.onTaskStarted(taskId);
        });
    }
}

export default DeleteOutboundPrivateLinkDialog;
